import {Button, Col, Row, Space} from "antd";
import {OfferingAutomations} from "../../../../../components/offering-form/automations-step";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {useCreateSubscriptionContext} from "../../context/create-subscription";

export function CreateSubscriptionAutomationsStep() {
  const {
    dispatch,
    state: {apiResponseData},
  } = useCreateSubscriptionContext();
  const contextOfferingId = apiResponseData?.productSubscription?.id ?? null;

  const goBack = () =>
    dispatch({
      type: "update-create-subscription-form-step",
      payload: "coverImagesUpload",
    });

  const goNext = () =>
    dispatch({
      type: "update-create-subscription-form-step",
      payload: "checkoutForm",
    });

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <OfferingAutomations
        contextOfferingId={contextOfferingId}
        onPublishSuccess={goNext}
        renderWizardFooter={() => (
          <Row gutter={[0, 16]}>
            <Col span={24} sm={12}>
              <StyledServiceButtonWrapper>
                <Button onClick={goBack} block size="small" type="default">
                  Back
                </Button>
                <Button block type="primary" size="small" onClick={goNext}>
                  Next
                </Button>
              </StyledServiceButtonWrapper>
            </Col>
          </Row>
        )}
      />
    </Space>
  );
}
